/**Modalità visualizzazione calendario: daily=0, monthly=1 */
export class CalendarViewMode {
    static daily = 1;
    static monthly = 0;
    static advancedSearch = 2;
}